import { QualificationItem } from "../types";

export const StatusIcon = ({ status }: { status: QualificationItem['status'] | 'needaction' }) => {
    switch (status) {
      case 'valid':
          return (
              <img src='/icon_valid.svg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)',
                  marginRight: '5px'
                }} />
              )
          
      case 'notvalid':
        return (
              <img src='/icon_status_notvalid.svg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)',
                  marginRight: '5px'
                }} />
            );
      case 'notqualified':
          return (
              <img src='/QualificationStatus.svg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)',
                  marginRight: '5px'
                }} />
            );
      case 'warning':
          return <img src='/icon_expiringsoon.svg' style={{
              fontFamily: 'var(--unnamed-font-family-inter)',
              fontStyle: 'var(--unnamed-font-style-normal)',
              fontWeight: 'var(--unnamed-font-weight-normal)',
              fontSize: 'var(--unnamed-font-size-14)',
              lineHeight: 'var(--unnamed-line-spacing-32)',
              letterSpacing: 'var(--unnamed-character-spacing-0)',
              color: 'var(--unnamed-color-1450f5)',
              marginRight: '5px'
            }} />
      case 'invalid':
          return (
              <img src='/icon_expired.svg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)',
                  marginRight: '5px'
                }} />
            );
      case 'needaction':
        return (
              <img src='/icon_status_attention.svg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)',
                  marginRight: '5px'
                }} />
            );
    }
  };